export enum EEntityAction {
  ADD = 'ADD',
  EDIT = 'EDIT',
}